var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExportIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6817 28.155C21.0327 28.3183 21.449 28.2693 21.7429 28.0244L37.514 14.9634C37.7426 14.7757 37.8732 14.49 37.8732 14.1961C37.8732 13.8941 37.7426 13.6165 37.5059 13.4288L21.7429 0.416767C21.4408 0.171873 21.0327 0.114732 20.6817 0.286157C20.3307 0.449419 20.1103 0.800433 20.1103 1.19226V8.02479C2.02896 8.67784 2.10243 22.3919 2.13508 29.0366V29.8285C2.13508 30.2856 2.43711 30.6774 2.87792 30.7917C2.95955 30.8162 3.04935 30.8244 3.13098 30.8244C3.48199 30.8244 3.81668 30.6366 4.00443 30.3183C9.34311 20.9143 13.7349 20.4572 20.1103 20.4327V27.2489C20.1103 27.6326 20.3307 27.9836 20.6817 28.155ZM4.15145 26.302C4.24124 23.4041 4.62491 19.9511 6.20855 17.0287C8.72279 12.3757 13.5962 10.0737 21.1144 10.0003C21.6613 9.9921 22.1021 9.55129 22.1021 9.00436V3.30651L35.3019 14.1961L22.1103 25.1184V19.4287C22.1103 19.1674 22.0042 18.9062 21.8164 18.7185C21.6287 18.5307 21.3756 18.4246 21.1062 18.4246C14.1104 18.4328 9.28605 18.8491 4.15145 26.302Z",
    fill: "#BD6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6773 39.1916V20.743C37.6773 20.1879 37.2283 19.7389 36.6733 19.7389C36.1182 19.7389 35.6692 20.1879 35.6692 20.743V38.1875H4.13508V34.7917C4.13508 34.2366 3.68611 33.7876 3.13102 33.7876C2.57592 33.7876 2.12695 34.2366 2.12695 34.7917V39.1834C2.12695 39.7385 2.57592 40.1875 3.13102 40.1875H36.6733C37.2283 40.1875 37.6773 39.7385 37.6773 39.1916Z",
    fill: "#BD6600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.1875)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/export-icon.6472e0c577d1c1e9798b43527633cce0.svg";
export { ForwardRef as ReactComponent };